<template>
  <div>
    <v-menu
      v-model="menuPractitioner"
      bottom
      right
      transition="scale-transition"
      origin="top left"
    >
      <template v-slot:activator="{ on }">
        <v-btn text large v-on="on">
          <PractitionerAvatar
            :id="practitionerLogged.profilePicture"
            size="27"
          ></PractitionerAvatar>

          <span class="body-2 font-weight-medium d-none d-sm-flex">
            {{ practitionerLogged.name }}
          </span>
        </v-btn>
      </template>
      <v-card>
        <v-list-item>
          <v-list-item-avatar size="40">
            <PractitionerAvatar
              :id="practitionerLogged.profilePicture"
              size="40"
            ></PractitionerAvatar>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="title primary--text">
              {{ practitionerLogged.name }}
            </v-list-item-title>
            <v-list-item-subtitle class="primary--text">
              {{ practitionerLogged.email }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#8acbdf"
            to="/costa-pez/usuario/mi-cuenta"
            class="secondary--text"
            rounded
            >Mi cuenta</v-btn
          >
          <v-btn
            @click="dialogLogout = true"
            color="red"
            dark
            text
            class="pl-3 pr-3 ml-5 mr-5"
            >Salir</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-menu>
    <v-dialog v-model="dialogLogout" max-width="600">
      <v-card>
        <v-card-title class="primary--text">Salir</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="title pt-8 pb-8"
          >¿Seguro deseas salir del sistema?</v-card-text
        >
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn text color="secondary" @click="dialogLogout = false"
            >Volver</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="logout" rounded width="100"
            >Salir</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PractitionerAvatar from "@/components/Practitioner/PractitionerAvatar";

export default {
  components: { PractitionerAvatar },
  data: () => ({
    dialogLogout: false,
    menuPractitioner: false
  }),
  computed: {
    practitionerLogged() {
      return this.$store.getters["authPractitioner/getPractitioner"];
    }
  },
  methods: {
    async logout() {
      try {
        this.dialogLogout = false;
        await this.$store.dispatch("authPractitioner/logout");
        this.$router.push({ name: "LandingPage" });
      } catch (err) {
        console.log(err);
      }
    }
  }
};
</script>

<style></style>
